'use strict';

var _ = require('lodash');
var GridMdReoptButtonController = function GridMdReoptButtonController($scope, $rootScope, $q, reoptimizationService, scenarioService, scenarioConstants, featureToggleService) {
  $scope.isMDReoptFeatureEnabled = featureToggleService.isEnabled('MD_PREVIEW_REOPT') && (featureToggleService.isEnabled('BREAK_CONNECTIONS') || !featureToggleService.isEnabled('MAPPED_MODE'));
  $scope.showMDButton = false;
  var gridPanel = $scope.gridPanelScope;
  var flightManagementGrids = ['inventory-management', 'overbooking-management'];
  $scope.onRowSelectionChanged = function (event, selectedRows) {
    if (isFlightManagementGrid()) {
      $scope.selectedRows = setSelectedRowsOnFlightManagement(selectedRows);
    } else {
      $scope.selectedRows = selectedRows;
    }
    $scope.showMDButton = $scope.isMDReoptFeatureEnabled && areSelectedRows() && !scenarioService.isScenarioSelected();
  };
  function isFlightManagementGrid() {
    return flightManagementGrids.indexOf(gridPanel.gridId) > -1;
  }
  function setSelectedRowsOnFlightManagement(selectedRows) {
    return _.size(selectedRows) > 0 ? selectedRows : _.get(gridPanel, 'jqxGridSettings.source.loadedData', []);
  }
  function areSelectedRows() {
    return _.size($scope.selectedRows);
  }
  $scope.sendMarketReopt = function () {
    reoptimizationService.reoptimizeMD($scope.selectedRows, scenarioConstants.PUBLISHED, false);
  };
  $scope.$watch('gridPanelScope.gridDataLoaded', function () {
    if (gridPanel.jqxGridSettings.source && isFlightManagementGrid()) {
      $scope.onRowSelectionChanged();
    }
  });
};
GridMdReoptButtonController.$inject = ['$scope', '$rootScope', '$q', 'ReoptimizationService', 'ScenarioService', 'ScenarioConstants', 'FeatureToggleService'];
module.exports = GridMdReoptButtonController;